<template>
  <div>
    <div v-if="loading">
      <p>Cargando..</p>
    </div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('orderapplications')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Crear Articulo
      </h1>
     
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
            Datos
          </a>
        </li>
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="store">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
             
          <text-input v-model="form.codigo" :error="form.errors.codigo" :req="form.codigo" class="pb-8 pr-6 w-full lg:w-1/6" label="Código" required/>
          <text-input v-model="form.description" :error="form.errors.description" :req="form.description" class="pb-8 pr-6 w-full lg:w-3/6" label="Descripción" required/>
          <div class="container pb-8 pr-6 w-full lg:w-2/6">
                <label class="form-label" >Grupo:</label>
                <v-select v-model="form.grupo_id" :options="grupos" value="id" label="Grupo" ></v-select>
                </div>  
                <div class="container pb-8 pr-6 w-full lg:w-1/6">
                <label class="form-label" >SubGrupo:</label>
                <v-select v-model="form.subgrupo_id" :options="subgrupos" value="id" label="SubGrupo" ></v-select>
                </div>
      
                <div class="container pb-8 pr-6 w-full lg:w-3/6">
                <label class="form-label" >SRI:</label>
                <v-select v-model="form.sri_id" :options="sris" value="id" label="Detalle" ></v-select>
                </div> 
                <div class="container pb-8 pr-6 w-full lg:w-1/6">
                <label class="form-label" >Iva:</label>
                <v-select v-model="form.iva_id" :options="ivas" value="id" label="Detalle" ></v-select>
                </div> 

                <text-input v-model="form.idOrder" :error="form.errors.idOrder" class="pb-8 pr-6 w-full lg:w-1/6" label="id" disabled/>

       </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Artículo</loading-button>
        </div>
      </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </div>
  <preloader />
  </div>
  
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  metaInfo: { title: 'Crear Proveedor' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    vSelect,
    DatePicker,
  },
  layout: Layout,
  props: {
    order: Object,
    grupo: Array,
    subgrupo: Array,
    sri: Array,
    iva: Array,
  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      loading: true,
      grupos: this.grupo,
      subgrupos: this.subgrupo,
      sris: this.sri,
      ivas: this.iva,
      form: this.$inertia.form({
        idOrder: this.order.id,
        codigo: '',
        description: '',
        grupo_id: null,
        subgrupo_id: null,
        sri_id: null,
        iva_id: null,
      }),
    }
  },
  async mounted(){
    await this.users
    this.loading=false
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    store() {
      
      this.form.post('/orderapplicationsarticle')
    },
   
  },
}
</script>